import * as React from 'react';
import { createApolloClient } from './graphql/client';
import { client } from '../../../../../client/__graphql__/client';
import { useParams } from 'react-router';
import { FormContextProvider } from './context/FormContextProvider';
import { ThemeProvider } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';
import { Form } from './Form';

export const VisningspaameldingFormStandalone: React.FC<{
  data: any;
  graph: string;
  onSubmit?: () => void;
}> = ({ data, graph, onSubmit }) => {
  const params = useParams<{ sguid: string }>();

  const pmvisninger = createApolloClient({
    graph: graph,
  });

  return (
    <ApolloProvider client={pmvisninger}>
      <FormContextProvider
        pmgraphClient={client}
        sguid={params.sguid}
        selectedIndex={0}
      >
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <Form
            data={data}
            nybygg={false}
            onSubmit={() => {
              if (typeof onSubmit === 'function') {
                onSubmit();
              }
            }}
          />
        </ThemeProvider>
      </FormContextProvider>
    </ApolloProvider>
  );
};
